import React, { useCallback, useEffect, useState } from 'react';
import styles from './TableSelect.module.css';
import searchIcon from '../common/Images/search.png';

const tableRowStyle = {
    display: 'grid',
    gridTemplateColumns: '30px 1fr 1fr',
    width: '100%',
    justifyContent: 'flex-start',
    padding: '2px 0px'
};

const tableHeaderRowStyle = {
    ...tableRowStyle,
    color: '#ffffff',
    backgroundColor: '#188ded',
    padding: '5px 0px',
    fontSize: 14,
    fontWeight: 'bold'
};

const tableRowTextCellStyle = {
    flex: 3,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: '0px 10px'
};

const grayRightBorder = {
    borderRight: '2px solid #999'
};

const whiteRightBorder = {
    borderRight: '2px solid #fff'
};

const headerTowCellStyle = {};

const searchContainerStyle = {
    padding: '10px 0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
};

const TableSelect = ({ options, changed, labelText, chosenOptions }) => {
    const [search, setSearch] = useState('');
    const [optionsToDisplay, setOptionsToDisplay] = useState(options);

    useEffect(() => {
        if (search) {
            const newOptions = options.filter((option) => {
                return option.name.toLowerCase().includes(search.toLowerCase());
            });
            setOptionsToDisplay(newOptions);
        } else {
            setOptionsToDisplay(options);
        }
    }, [options, search]);

    const onCheckboxStateChanged = useCallback(
        (newState, option) => {
            changed(newState, option);
        },
        [changed]
    );

    return (
        <div style={{ paddingRight: '10px' }}>
            <div style={searchContainerStyle}>
                <div>{labelText}</div>
                <div className={styles.search}>
                    <img src={searchIcon} alt={''} />
                    <input
                        type="text"
                        placeholder="Search..."
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                    />
                </div>
            </div>
            <div style={tableHeaderRowStyle}>
                <div
                    style={{
                        ...headerTowCellStyle,
                        flex: 1,
                        padding: '0px 5px 0px 10px',
                        textAlign: 'center'
                    }}></div>
                <div style={{ ...whiteRightBorder, ...headerTowCellStyle, flex: 3, padding: '0px 10px' }}>Entity</div>
                <div style={{ ...headerTowCellStyle, flex: 3, padding: '0px 10px' }}>Availability Zone</div>
            </div>
            <div className={styles.disableScrollbars}>
                {optionsToDisplay.map((option) => {
                    return (
                        <div style={tableRowStyle} key={option.id}>
                            <div
                                style={{
                                    ...headerTowCellStyle,
                                    flex: 1,
                                    padding: '0px 5px 0px 10px',
                                    textAlign: 'center'
                                }}>
                                <input
                                    type={'checkbox'}
                                    onChange={(event) => {
                                        onCheckboxStateChanged(event.target.checked, option);
                                    }}
                                    checked={
                                        chosenOptions.find((chosenOption) => option.id === chosenOption.id) || false
                                    }
                                />
                            </div>
                            <div
                                style={{
                                    ...tableRowTextCellStyle,
                                    ...grayRightBorder
                                }}>
                                {option.name}
                            </div>
                            <div style={tableRowTextCellStyle}>{option.az}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TableSelect;
